import React from 'react';
import { MarketIQLayout } from '../components/MarketIQLayout';
import { MarketIQNav } from '../components/MarketIQNav';
import { PorkCutoutChart } from '../components/PorkCutoutChart';
import { PorkCutoutTable } from '../components/PorkCutoutTable';
export function MarketIQPork() {
  return <MarketIQLayout activeSection="pork" data-id="element-506">
      <PorkCutoutChart data-id="element-507" />
      <MarketIQNav current="pork" data-id="element-508" />
      <PorkCutoutTable data-id="element-509" />
    </MarketIQLayout>;
}